import Lines from '../components/common/Lines';
import ProgressScroll from '../components/common/ProgressScroll';
import Cursor from '../components/common/cusor';
import Blog from '../components/home-main/Blog';
import LoadingScreen from '../components/common/loader';
import Footer from '../components/common/Footer';
import Navbar from '../components/common/Navbar';
import Marq2 from '../components/common/Marq2';
import { Helmet } from 'react-helmet';
import Header from '../components/home-main/Header';
import Intro from '../components/home-main/Intro';
import Feat from '../components/home-main/Feat';
import Cultura from '../components/home-main/Cultura';
import Experiencias from '../components/home-main/Experiencias';
import WOW from 'wowjs';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { ScrollSmoother } from 'gsap-trial/ScrollSmoother';

import { useGSAP } from '@gsap/react';
import { useEffect, useRef } from 'react';
gsap.registerPlugin(useGSAP, ScrollTrigger);

export default function HomeMain() {
  const main = useRef();
  const ogImageUrl = typeof window !== 'undefined' 
    ? `${window.location.origin}/assets/imgs/productos/definitivos/mandarina.jpg`
    : '/assets/imgs/productos/definitivos/mandarina.jpg';

  useEffect(() => {
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        // Verificar si el script ya está cargado
        const existingScript = document.querySelector(`script[src="${src}"]`);
        if (existingScript) {
          resolve(true);
          return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.async = false; // Cambiar a false para asegurar orden secuencial

        script.onload = () => {
          resolve(true);
        };

        script.onerror = () => {
          reject(new Error(`Failed to load ${src}`));
        };

        document.body.appendChild(script);
      });
    };

    // Esperar a que GSAP esté disponible antes de cargar ScrollTrigger y ScrollSmoother
    const initScrollSmoother = async () => {
      try {
        // Esperar a que gsap.min.js esté disponible
        if (typeof window !== 'undefined' && !window.gsap) {
          await new Promise((resolve) => {
            const checkGSAP = setInterval(() => {
              if (window.gsap) {
                clearInterval(checkGSAP);
                resolve();
              }
            }, 100);
            // Timeout después de 5 segundos
            setTimeout(() => {
              clearInterval(checkGSAP);
              resolve();
            }, 5000);
          });
        }

        // Cargar ScrollTrigger primero
        await loadScript('/assets/js/ScrollTrigger.min.js');
        
        // Registrar ScrollTrigger con GSAP
        if (window.gsap && window.ScrollTrigger) {
          window.gsap.registerPlugin(window.ScrollTrigger);
        }

        // Cargar ScrollSmoother después
        await loadScript('/assets/js/ScrollSmoother.min.js');
        
        // Registrar ScrollSmoother con GSAP
        if (window.gsap && window.ScrollSmoother) {
          window.gsap.registerPlugin(window.ScrollSmoother);
        }

        // Finalmente cargar smoother-script.js que inicializa ScrollSmoother
        await loadScript('/assets/js/smoother-script.js');
      } catch (error) {
        console.error('Error loading scroll libraries:', error);
      }
    };

    initScrollSmoother();
  }, []);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      new WOW.WOW({
        animateClass: 'animated',
        offset: 100,
      }).init();
    }
  }, []);
  return (
    <>
      <Helmet>
        <title>Citricos Naturales</title>
        <meta name="description" content="En Cítricos Naturales nos aseguramos de que cada jugo no solo refresque, sino que también ofrezca la máxima potencia y riqueza del poder de los cítricos recién cosechados. Gracias al extracto de fruta fresca, podemos ofrecerte un sabor que transporta directamente al origen y que captura la vitalidad pura de la naturaleza." />
        <meta property="og:title" content="Citricos Naturales" />
        <meta property="og:description" content="En Cítricos Naturales nos aseguramos de que cada jugo no solo refresque, sino que también ofrezca la máxima potencia y riqueza del poder de los cítricos recién cosechados. Gracias al extracto de fruta fresca, podemos ofrecerte un sabor que transporta directamente al origen y que captura la vitalidad pura de la naturaleza." />
        <meta property="og:image" content={ogImageUrl} />
        <meta property="og:type" content="website" />
        <link rel="icon" href="/assets/imgs/logo-light.png" />
        <link rel="shortcut icon" href="/assets/imgs/logo-light.png" />
        <link rel="stylesheet" type="text/css" href="/assets/css/plugins.css" />
        <link rel="stylesheet" type="text/css" href="/assets/css/style.css" />

        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@200;300;400;500;600;700&display=swap"
        />
        {/* ScrollTrigger y ScrollSmoother se cargan dinámicamente en useEffect para evitar conflictos */}
        <script defer src="/assets/js/gsap.min.js"></script>
        <script defer src="/assets/js/splitting.min.js"></script>
        <script defer src="/assets/js/isotope.pkgd.min.js"></script>
        <script defer src="/assets/js/plugins.js"></script>
        <script defer src="/assets/js/TweenMax.min.js"></script>
        <script defer src="/assets/js/charming.min.js"></script>
        <script defer src="/assets/js/countdown.js"></script>
      </Helmet>
      <body>
        <LoadingScreen />
        <Cursor />
        <ProgressScroll />
        <Lines />
        <Navbar />
        <div id="smooth-wrapper" ref={main}>
          <div id="smooth-content">
            <main className="main-bg o-hidden">
              <Header />
              <Feat />

              <Intro />
              <Cultura />
              <Experiencias />
              <Blog />

              <Marq2 />
            </main>
            <Footer />
          </div>
        </div>
      </body>
    </>
  );
}
